import a from "./ghl-ui.es1506.js";
import n from "./ghl-ui.es1466.js";
function m(e) {
  n(1, arguments);
  var t = a(e), r = t.getMonth(), o = r - r % 3;
  return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
}
export {
  m as default
};
